import FormGroupRenderer from '@app/components/FormGroupRenderer'
import PageSection from '@app/components/PageSection'
import TransactionHistoryModal from '@app/components/TransactionHistoryModal'
import TypeAheadList from '@app/components/TypeAheadList'
import { Comp, IComp } from '@app/models/Comp'
import { ITransactionHistory } from '@app/models/TransactionHistory'
import {
  actionCreators as globalActionCreators,
  IGlobalCompsState,
} from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { formatCurrency, formatDate } from '@app/utils/formatting'
import * as React from 'react'

interface IComponentProps {
  onChange: (e: IComp) => void
}

interface IComponentState {
  comp: IComp
  isOpen: boolean
  propertyId: string
}

export default class CompsEditor extends React.PureComponent<
  IComponentProps & IGlobalCompsState & typeof globalActionCreators,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      comp: new Comp().toJS(),
      isOpen: false,
      propertyId: '',
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <PageSection title='Comps'>
        <FormGroupRenderer>
          <TypeAheadList
            clearInputAfterSelection={true}
            dataSource={this.props.comps}
            value=''
            placeholder='Enter a property to comp...'
            labelKey='propertyName'
            _renderSuggestion={this._renderItem}
            _onSuggestionFetchRequested={this._getComps}
            onChange={this._addCompOrCreateTransaction}
          />

          <TransactionHistoryModal
            cancelModal={(e: boolean) => this.setState({ isOpen: e })}
            confirmClick={this._assignValuesToComp}
            comp={this.state.comp}
            isOpen={this.state.isOpen}
            persistToServer={true}
            propertyId={this.state.propertyId}
          />
        </FormGroupRenderer>
      </PageSection>
    )
  }

  private _addCompOrCreateTransaction(value: IComp) {
    if (!value.lastSalePrice) {
      // open transaction modal
      this.setState({
        comp: (value as Comp).toJS(),
        isOpen: true,
        propertyId: value.propertyId,
      })
    } else {
      // add comp
      this.props.onChange(value)
    }
  }

  private _assignValuesToComp(e: ITransactionHistory) {
    const comp = { ...this.state.comp }
    comp.lastSalePrice = e.salePrice
    comp.lastSaleDate = e.saleDate

    this.props.onChange(Comp.fromJS(comp))

    this.setState({
      comp: new Comp().toJS(),
      isOpen: false,
      propertyId: '',
    })
  }

  private _getComps(item: any) {
    this.props.getComps(item.value)
  }

  private _renderItem(suggestion: IComp) {
    return (
      <div>
        <div>
          <div>{suggestion.propertyName}</div>
          {suggestion.lastSalePrice
            ? `${formatDate(
                suggestion.lastSaleDate,
                'MM/DD/YYYY',
              )} - ${formatCurrency(suggestion.lastSalePrice)}`
            : ''}
        </div>
      </div>
    )
  }
}
